import { combineReducers } from 'redux'
import contacts from './contacts.reducer'
import matches from './matches.reducer'
import organizations from './organizations.reducer'
import merge from './merge.reducer'

export default combineReducers({
  contacts,
  matches,
  organizations,
  merge
})
